"use strict";

class BlacklistOccupationsController {

    constructor($timeout, SSHttpService, SSAlertService, SSUserService, SSConfirmationService, SSEoiService, SSUtilService) {
        const self = this;

        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSEoiService = SSEoiService;
        self.SSUtilService = SSUtilService;

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.getDeveloperSettings();
    }

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings/by-name?name=blacklist_occupations';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){
                // Get Suspicious Occupation List Settings
                self.occupations_blacklist_settings = self.getSetting(response.data.developer_settings, 'blacklist_occupations');
                if(self.occupations_blacklist_settings
                        && self.occupations_blacklist_settings.value){
                    self.occupations_blacklist_settings.value = self.parseOccupationsBlacklistForDisplay(self.occupations_blacklist_settings.value);
                    if (self.occupations_blacklist_settings.value.length) {
                        self.occupations_blacklist = self.occupations_blacklist_settings.value;
                        self.haveBlacklistedOccupations = true;
                        // TODO: If blacklisted occupations exist, update non-blacklisted occupations list
                        self.$timeout(function () {
                            $("select.eoi-select").niceSelect('update');
                        });
                    }
                }
            }
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!settings || !settings.length || !setting_name){ return null; }

        let setting = settings.find(s => s.name == setting_name);
        try{
            if (setting && setting.value && typeof setting.value == "string") {
                setting.value = JSON.parse(setting.value);
            }
        }
        catch(ex){ console.error(ex); }
        return setting;
    }

    addOccupationBlacklistEntry() {
        const self = this;

        if (self.isValidOccupationBlacklistEntry()) {
            self.duplicate_error = false
            self.occupations_blacklist = self.occupations_blacklist || [];
            if (!self.occupations_blacklist.find(o => {
                    let industry_match = self.selectedIndustryForBlackList === "OTHERS" ? self.selectedOtherIndustryForBlackList: self.selectedIndustryForBlackList;
                    let occupation_match = self.selectedOccupationForBlackList === "OTHERS" ? self.selectedOtherOccupationForBlackList: self.selectedOccupationForBlackList;
                    return o.industry === industry_match && o.occupation === occupation_match;
                })) {
                // If entry does not already exist, add new
                self.occupations_blacklist.push({
                    industry: self.selectedIndustryForBlackList === "OTHERS" ? self.selectedOtherIndustryForBlackList: self.selectedIndustryForBlackList,
                    occupation: self.selectedOccupationForBlackList === "OTHERS" ? self.selectedOtherOccupationForBlackList : self.selectedOccupationForBlackList
                });

                // TODO: Update non-blacklisted occupations list
                self.$timeout(function () {
                    $("select.eoi-select").niceSelect('update');
                });

                // Clear fields
                self.selectedIndustryForBlackList = null;
                self.selectedOccupationForBlackList = null;
                self.selectedOtherIndustryForBlackList = null;
                self.selectedOtherOccupationForBlackList = null;
            } else { // Duplicate Entry
                self.duplicate_error = true;
            }
        }
    }

    isValidOccupationBlacklistEntry() {
        const self = this;

        let isValid  = true;
        self.errors = {};
        if (!self.selectedIndustryForBlackList) {
            self.errors.industry = "Please select Industry";
            isValid = false;
        }

        if (self.selectedIndustryForBlackList
            && self.selectedIndustryForBlackList === "OTHERS"
            && !self.selectedOtherIndustryForBlackList) {
            self.errors.industry_other = "Please enter Industry";
            isValid = false;
        }

        if (!self.selectedOccupationForBlackList) {
            self.errors.occupation = "Please select Occupation";
            isValid = false;
        }

        if (self.selectedOccupationForBlackList
                && self.selectedOccupationForBlackList === "OTHERS"
                && !self.selectedOtherOccupationForBlackList) {
            self.errors.occupation_other = "Please enter Occupation";
            isValid = false;
        }

        return isValid;
    }

    removeOccupationBlacklistEntry(occupation_entry){
        const self = this;

        self.occupations_blacklist = self.occupations_blacklist || [];
        if (occupation_entry && occupation_entry.industry && occupation_entry.occupation) {
            self.duplicate_error = false;
            self.occupations_blacklist = self.occupations_blacklist
                .filter(o => o.industry !== occupation_entry.industry || o.occupation !== occupation_entry.occupation)

            // TODO: Update non-blacklisted occupations list
            self.$timeout(function () {
                $("select.eoi-select").niceSelect('update');
            });
        }
    }

    _saveOccupationBlacklistSettings(){
        const self = this;

        let occupations_blacklist = self.parseOccupationsBlacklistForSaving(self.occupations_blacklist); // Parse blacklist object

        let url = 'sec/developer/settings';
        let params = {
            name: "blacklist_occupations",
            value: JSON.stringify(occupations_blacklist)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.isEditOccupationBlacklist = false;
            self.haveBlacklistedOccupations = false;
            self.SSAlertService.success('Success!', 'Suspicious Occupation List settings updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.occupations_blacklist_settings && self.occupations_blacklist_settings.id) {
            url += '/' + self.occupations_blacklist_settings.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    parseOccupationsBlacklistForSaving(blacklist) {
        if (!blacklist || !blacklist.length) { return  {}; } // If blacklist is empty set empty object

        let parsedList = {};
        blacklist.forEach(e => {
            parsedList[e.industry] = parsedList[e.industry] || []; // If no entries against industry, set empty array
            if (parsedList[e.industry].indexOf(e.occupation) <= -1) {
                parsedList[e.industry].push(e.occupation); // Push occupations in industry array
            }
        })
        return parsedList;
    }

    parseOccupationsBlacklistForDisplay(blacklist) {
        if (!blacklist || !Object.keys(blacklist).length) { return  []; } // If blacklist is empty set empty array

        let parsedList = [];
        Object.keys(blacklist).forEach(industry => { // Loop all industries
            if (blacklist[industry] && blacklist[industry].length) {
                blacklist[industry].forEach(occupation => { // Loop all occupations and add new object with industry and occupation
                    parsedList.push({industry, occupation });
                })
            }
        })
        return parsedList;
    }

    onEditOccupationBlacklistSettings(){
        const self = this;

        if (self.occupations_blacklist_settings && self.occupations_blacklist_settings.value) {
            self.occupations_blacklist = angular.copy(self.occupations_blacklist_settings.value);
        }

        // Clear fields
        self.errors = {};
        self.duplicate_error = false
        self.selectedIndustryForBlackList = null;
        self.selectedOccupationForBlackList = null;
        self.selectedOtherIndustryForBlackList = null;
        self.selectedOtherOccupationForBlackList = null;

        // Set Edit flag
        self.isEditOccupationBlacklist = true;
        
        self.$timeout(function () {
            $("select.eoi-select").niceSelect('update');
        });
    }

    onCancelOccupationBlacklistSettings(){
        const self = this;

        self.occupations_blacklist = [];
        if (self.occupations_blacklist_settings && self.occupations_blacklist_settings.value) {
            self.occupations_blacklist = angular.copy(self.occupations_blacklist_settings.value);
        }

        if(!self.occupations_blacklist.length){
            self.haveBlacklistedOccupations = false; // Set toggle disabled if list is empty
        }
        self.isEditOccupationBlacklist = false;
    }

    onEnableDisableOccupationBlacklist(){
        const self = this;

        if(self.haveBlacklistedOccupations){
            self.haveBlacklistedOccupations = false;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to enable Suspicious Occupation List?',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    self.haveBlacklistedOccupations = true;
                    self.occupations_blacklist = [];
                }
            );
        } else {
            self.haveBlacklistedOccupations = true;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to proceed to disable Suspicious Occupation List? \nThe list will be removed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function (answer) {
                    self.haveBlacklistedOccupations = false;
                    self.occupations_blacklist = [];
                    self._saveOccupationBlacklistSettings();
                }
            );
        }
    }

    updateOccupationSelector() {
        const self = this;
        self.$timeout(function () {
            $("select.eoi-select#occupation").niceSelect('update');
        });
    }

}

BlacklistOccupationsController.$inject = [
    '$timeout',
    'SSHttpService',
    'SSAlertService',
    'SSUserService',
    'SSConfirmationService',
    'SSEoiService',
    'SSUtilService'];
app.controller('BlacklistOccupationsController', BlacklistOccupationsController);
